








































import {Component, Vue} from 'vue-property-decorator'
import AppHeader from '@/components/common/AppHeader.vue'
import AppFooter from '@/components/common/AppFooter.vue'
import {Getter, Action} from 'vuex-class'
import {Notification} from '@/store/types'
import FontAwesome from '@/classes/FontAwesome'

@Component({
    components: {
        AppHeader,
        AppFooter,
    },
})
export default class Inbox extends Vue {
    @Getter('notificationList') public notificationList!: Notification[]
    @Getter('notificationsLoader') public notificationsLoader!: any
    @Action ('markNotificationAsRead') public markNotificationAsRead!: any
    @Action ('readAll') public readAll!: any
    @Action ('loadNotifications') public loadNotifications!: any

    public FontAwesome = FontAwesome

    public checkMarkNotificationAsRead(notification: Notification) {
      if ( !notification.read_at ) {
        this.markNotificationAsRead(notification)
      }
    }
}
